import { render } from "./OrbitPerturbedLegend.vue?vue&type=template&id=ac89feb2"
import script from "./OrbitPerturbedLegend.vue?vue&type=script&lang=js"
export * from "./OrbitPerturbedLegend.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__